import { tv } from "tailwind-variants"
import { SubscriptionStatusesEnum, UseMyMembershipQuery } from "../../../types.graphql"
import { twMerge } from "tailwind-merge"
import { formatNiceShortDate } from "@utils/dates"
import { MakeURL } from "@utils/create-url"
import { Link } from "eddev/routing"

export function MembershipAlertBanner({ data, className }: { data: UseMyMembershipQuery | null | undefined; className?: string }) {
  const status = data?.customer?.memberStatus
  const statusKind = status?.subscription?.status
  if (!status || !statusKind) {
    return null
  }

  let message = null
  let link: null | { label: string; url: string } = null

  if (statusKind === SubscriptionStatusesEnum.Expired) {
    message = `Your membership ${status.expiryDate ? "expired on " + formatNiceShortDate(status.expiryDate) : "has expired"}. Please renew to continue accessing member benefits.`
    link = {
      label: "Renew Membership",
      url: MakeURL.renew(),
    }
  } else if (statusKind === SubscriptionStatusesEnum.OnHold) {
    message = `Your membership is on hold or has expired. Please contact us to reactivate.`
    link = {
      label: "Contact Us",
      url: MakeURL.contact(),
    }
  } else if (statusKind === SubscriptionStatusesEnum.Active && status.expiresSoon && status.canRenew && status.needsPayment) {
    message = `Your membership will expire ${status.expiryDate ? "on " + formatNiceShortDate(status.expiryDate) : "soon"}, since no payment method is on file or auto-renew is not enabled. Please update your payment method before your next renewal date to continue accessing member benefits.`
  } else if (statusKind === SubscriptionStatusesEnum.Active && status.requiresAction) {
    message = `Your membership is active, but your payment method is out of date. Please update your payment method before your next renewal date ${status.nextBillDate ? "on " + formatNiceShortDate(status.nextBillDate) + "." : "."}`
    link = {
      label: "Renew Membership",
      url: MakeURL.renew(),
    }
  }

  if (!message) return null

  return (
    <div className={"border-transparent border-t border-b flex flex-col justify-center type-body-m-roman"}>
      <div className={twMerge("border py-2 px-3", "text-error-dark bg-error-light", className)}>
        {message}

        {!!link && (
          <div className="mt-1">
            <Link href={link.url} className="type-body-s-roman underline opacity-80 decoration-error-dark/40 hover:opacity-100 transition-opacity">
              {link.label}
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}
